const bugalowTypeOptions = [
  { value: 12, name: 'Bungalow' },
  { value: 15, name: 'Detached Bungalow' },
  { value: 14, name: 'Semi-Detached Bungalow' },
  { value: 13, name: 'Terraced Bungalow' }
]

const characterPropertyTypeOptions = [
  { value: 68, name: 'Barn Conversion' },
  { value: 92, name: 'Castle' },
  { value: 101, name: 'Cave House' },
  { value: 25, name: 'Character Property' },
  { value: 104, name: 'Cortijo' },
  { value: 113, name: 'Country House' },
  { value: 53, name: 'Equestrian' },
  { value: 52, name: 'Farm House' },
  { value: 65, name: 'Gite' },
  { value: 141, name: 'House Boat' },
  { value: 118, name: 'Lodge' },
  { value: 119, name: 'Log Cabin' },
  { value: 62, name: 'Longere' },
  { value: 120, name: 'Manor House' },
  { value: 74, name: 'Mill' },
  { value: 140, name: 'Riad' },
  { value: 77, name: 'Ruins' },
  { value: 116, name: 'Stone House' },
  { value: 71, name: 'Trulli' }
]

const commercialPropertyTypeOptions = [
  { value: 134, name: 'Bar' },
  { value: 284, name: 'Beach / Ocean Front' },
  { value: 181, name: 'Business Park' },
  { value: 83, name: 'Café' },
  { value: 244, name: 'Commercial Development' },
  { value: 253, name: 'Commercial Property' },
  { value: 193, name: 'Convenience Store' },
  { value: 256, name: 'Data Centre' },
  { value: 1009, name: 'Development' },
  { value: 217, name: 'Distribution Warehouse' },
  { value: 286, name: 'Equestrian' },
  { value: 220, name: 'Factory' },
  { value: 259, name: 'Farm' },
  { value: 1022, name: 'Farm - Livestock' },
  { value: 288, name: 'Farms &amp; Ranches' },
  { value: 9998, name: 'Game Farms' },
  { value: 9999, name: 'Game Lodges' },
  { value: 196, name: 'Garage' },
  { value: 287, name: 'Golf' },
  { value: 1016, name: 'Guest Farm' },
  { value: 277, name: 'Guest House' },
  { value: 199, name: 'Hairdresser / Barber Shop' },
  { value: 262, name: 'Healthcare Facility' },
  { value: 1021, name: 'Historic Farm' },
  { value: 280, name: 'Hospitality' },
  { value: 202, name: 'Hotel' },
  { value: 226, name: 'Industrial Park' },
  { value: 1002, name: 'Industrial/Warehouse' },
  { value: 241, name: 'Land' },
  { value: 283, name: 'Leisure Facility' },
  { value: 229, name: 'Light Industrial' },
  { value: 265, name: 'Marine Property' },
  { value: 86, name: 'Mill' },
  { value: 268, name: 'Mixed Use' },
  { value: 178, name: 'Office' },
  { value: 1003, name: 'Office Sharing' },
  { value: 1000, name: 'Offices' },
  { value: 205, name: 'Petrol Station' },
  { value: 208, name: 'Post Office' },
  { value: 211, name: 'Pub' },
  { value: 271, name: 'Research &amp; Development Facility' },
  { value: 250, name: 'Residential Development' },
  { value: 80, name: 'Restaurant' },
  { value: 187, name: 'Retail Property (High Street)' },
  { value: 190, name: 'Retail Property (Out of Town)' },
  { value: 274, name: 'Science Park' },
  { value: 1005, name: 'Sectional Title' },
  { value: 1006, name: 'Secure Estate' },
  { value: 1007, name: 'Secure Golfing Estate' },
  { value: 1008, name: 'Secure Wild Life Estate' },
  { value: 184, name: 'Serviced Office' },
  { value: 1004, name: 'Serviced Offices' },
  { value: 137, name: 'Shop' },
  { value: 1001, name: 'Shops' },
  { value: 235, name: 'Showroom' },
  { value: 1032, name: 'Smallholding - 2-50 Acres' },
  { value: 232, name: 'Storage' },
  { value: 89, name: 'Trulli' },
  { value: 1010, name: 'Vacant Land' },
  { value: 289, name: 'Vacation Rentals' },
  { value: 238, name: 'Warehouse' },
  { value: 285, name: 'Water Front' },
  { value: 1018, name: 'Winery' },
  { value: 214, name: 'Workshop &amp; Retail Space' }
]

const dateOptions = [
  { value: '7_day', name: 'Last 7 days' },
  { value: '14_day', name: 'Last 14 days' },
  { value: '1_month', name: 'Last 1 month' },
  { value: '3_month', name: 'Last 3 months' },
  { value: '6_month', name: 'Last 6 months' },
  { value: '9_month', name: 'Last 9 months' },
  { value: '12_month', name: 'Last year' },
  { value: '15_month', name: 'Last 15 months' },
  { value: '18_month', name: 'Last 18 months' },
  { value: '21_month', name: 'Last 21 months' },
  { value: '24_month', name: 'Last 2 years' },
  { value: '36_month', name: 'Last 3 years' },
  { value: '48_month', name: 'Last 4 years' },
  { value: '5_years', name: 'Last 5 years' },
  { value: '6_years', name: 'Last 6 years' },
  { value: '7_years', name: 'Last 7 years' },
  { value: '8_years', name: 'Last 8 years' },
  { value: '9_years', name: 'Last 9 years' },
  { value: '10_years', name: 'Last 10 years' },
  { value: null, name: 'All Time' }
]

const distanceOptions = [
  { value: 0.25, name: 'Within 1/4 mile' },
  { value: 0.5, name: 'Within 1/2 mile' },
  { value: 1, name: 'Within 1 mile' },
  { value: 3, name: 'Within 3 miles' },
  { value: 5, name: 'Within 5 miles' },
  { value: 10, name: 'Within 10 miles' },
  { value: 15, name: 'Within 15 miles' },
  { value: 20, name: 'Within 20 miles' },
  { value: 30, name: 'Within 30 miles' },
  { value: 50, name: 'Within 50 miles' }
]

const flatTypeOptions = [
  { value: 28, name: 'Apartment' },
  { value: 143, name: 'Block of Apartments' },
  { value: 511, name: 'Coach House' },
  { value: 56, name: 'Duplex' },
  { value: 8, name: 'Flat' },
  { value: 7, name: 'Ground Flat' },
  { value: 1034, name: 'Ground Floor Apartment' },
  { value: 10, name: 'Ground Maisonette' },
  { value: 1038, name: 'Luxury Apartment' },
  { value: 11, name: 'Maisonette' },
  { value: 29, name: 'Penthouse' },
  { value: 144, name: 'Private Halls' },
  { value: 44, name: 'Serviced Apartment' },
  { value: 9, name: 'Studio' },
  { value: 59, name: 'Triplex' }
]

const houseTypeOptions = [
  { value: 0, name: 'Not Specified' },
  { value: 6, name: 'Cluster House' },
  { value: 23, name: 'Cottage' },
  { value: 1014, name: 'Garden Cottage' },
  { value: 4, name: 'Detached House' },
  { value: 30, name: 'Finca' },
  { value: 26, name: 'House' },
  { value: 1025, name: 'House - With Land' },
  { value: 1024, name: 'House with additional accommodation' },
  { value: 21, name: 'Link Detached House' },
  { value: 5, name: 'Mews House' },
  { value: 3, name: 'Mews HouseSemi-Detached House' },
  { value: 128, name: 'Semi-Detached Villa' },
  { value: 1, name: 'Terraced House' },
  { value: 22, name: 'Town House' },
  { value: 27, name: 'Villa' },
  { value: 95, name: 'Village House' }
]

const landTypeOptions = [
  { value: 107, name: 'Farm Land' },
  { value: 20, name: 'Land' },
  { value: 125, name: 'Off-Plan' },
  { value: 110, name: 'Plot' }
]

const otherTypeOptions = [
  { value: 51, name: 'Garage' },
  { value: 5, name: 'Parking' },
  { value: 18, name: 'Guest House' },
  { value: 17, name: 'Hotel' },
  { value: 49, name: 'Flat Share' },
  { value: 48, name: 'House Share' },
  { value: 117, name: 'Caravan' },
  { value: 16, name: 'Mobile Home' },
  { value: 50, name: 'Park Home' },
  { value: 47, name: 'Retirement Property' },
  { value: 46, name: 'Sheltered Housing' }
]

const propertyStatusOptions = [
  { id: 1, name: 'Available' },
  { id: 2, name: 'SSTC' },
  { id: 3, name: 'SSTCM' },
  { id: 4, name: 'Under Offer' },
  { id: 5, name: 'Reserved' },
  { id: 6, name: 'Let Agreed' },
  { id: 7, name: 'Sold' },
  { id: 8, name: 'Let' },
  { id: 9, name: 'Exchanged' },
  { id: 10, name: 'Completed' },
  { id: 11, name: 'Withdrawn' }
]

const propertyGroupOptions = [
  { value: 0, name: 'Not Specified' },
  { value: 1, name: 'House' },
  { value: 2, name: 'Flat / Apartment' },
  { value: 3, name: 'Bungalow' },
  { value: 4, name: 'Character Property' },
  { value: 5, name: 'Commercial Property' },
  { value: 6, name: 'Garage / Parking' },
  { value: 7, name: 'Guest House / Hotel' },
  { value: 8, name: 'House / Flat Share' },
  { value: 9, name: 'Land' },
  { value: 10, name: 'Mobile / Park Home' },
  { value: 11, name: 'Retirement Property' }
]
const bedroomOptions = [
  { value: null, name: 'All Bedrooms' },
  { value: 1, name: '1+ Bedrooms' },
  { value: 2, name: '2+ Bedrooms' },
  { value: 3, name: '3+ Bedrooms' },
  { value: 4, name: '4+ Bedrooms' },
  { value: 5, name: '5+ Bedrooms' },
  { value: 6, name: '6+ Bedrooms' },
  { value: 7, name: '7+ Bedrooms' },
  { value: 8, name: '8+ Bedrooms' },
  { value: 9, name: '9+ Bedrooms' },
  { value: 10, name: '10+ Bedrooms' }
]

export { bugalowTypeOptions, characterPropertyTypeOptions, commercialPropertyTypeOptions, dateOptions, distanceOptions, flatTypeOptions, houseTypeOptions, landTypeOptions, propertyStatusOptions, bedroomOptions, otherTypeOptions, propertyGroupOptions }
